/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ae55739b52fc998646727a2b6b5297a866a11aa5";
